import { render } from "./WizardActionButton.vue?vue&type=template&id=212a39f4&scoped=true"
import script from "./WizardActionButton.vue?vue&type=script&lang=ts"
export * from "./WizardActionButton.vue?vue&type=script&lang=ts"

import "./WizardActionButton.vue?vue&type=style&index=0&id=212a39f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-212a39f4"

export default script